import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import Tooltip from 'reactstrap/lib/UncontrolledTooltip';
import EventDetails from './EventDetails/EventDetails';
import EventDates from './EventDates/EventDates';
import EventPoster from './EventPoster/EventPoster';
import moment from 'moment-timezone';
import { SetComponentLanguage, ApiRequest, ReturnTimeZone } from '../../../helpers';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import PrinterOptions from '../../Common/PrinterOptions/PrinterOptions';
import LocalizedStrings from 'react-localization';
import Tour from 'reactour';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './Event.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

const steps = [
	{
	  selector: '[data-event-type="Live Stream"] .showtix-event__dates .showtix-button',
	  content: 'First, click on the Buy Stream button.',
    },
    {
        selector: '[data-event-type="Live Stream"] .showtix-event__dates__panel .showtix-event__settings',
        content: 'Then, click on the Settings button next to a specific date and look for your Live Streaming Credentials.',
    }
];

class Event extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCredentialsOpen: false,
            isRehearsalCredentialsOpen: false,
            rehearsal: {
                vimeo_rtmp_url: '',
                vimeo_stream_key: '',
                stream_code: '',
            },
            live: {
                vimeo_rtmp_url: '',
                vimeo_stream_key: '',
                stream_code: '',
            },
            isTourOpen: false,
        };
    }

    componentWillReceiveProps(props) {
        //this.getRehearsalCredentials(props.event.id, false);
    }

    startTour = () => {
		this.setState({
			isTourOpen: true,
		});
	}

    closeTour = () => {
		this.setState({
			isTourOpen: false,
		});
    }

    printerSelect = () => {
        return (
            <div className="showtix-form__group">
                <div className="showtix-form__select">
                    {this.props.printers.length > 0 ?
                        <select className="showtix-input"
                            value={this.props.currentPrinter}
                            onChange={this.props.handlePrinterChange}>
                            <PrinterOptions printers={this.props.printers} />
                        </select> :
                        <h2>{strings.noPrinterAvailable}</h2>
                    }
                </div>
            </div>
        )
    }

    printerSelectBoca = () => {
        return (
            <div className="showtix-form__group">
                <div className="showtix-form__select">
                    {this.props.printersBoca.length > 0 ?
                        <select className="showtix-input"
                                value={this.props.currentPrinterBoca}
                                onChange={this.props.handlePrinterChangeBoca}>
                            <option>Select</option>
                            {this.props.printersBoca.map((printer, i) => (
                                <option value={this.props.printersBoca[i].name}>{this.props.printersBoca[i].name}</option>
                            ))}
                        </select> :
                        <h2>{strings.noPrinterAvailable}</h2>
                    }
                </div>
            </div>
        )
    }

    getCredentials = async(event_date_id) => {
        let live = this.state.live;
        try {
            const response = await getCredentialsInfo(event_date_id);
            console.log('getCredentialsInfo', response);
            if (response.data.vimeo_rtmp_url && response.data.vimeo_rtmp_url !== '') {
                live.vimeo_rtmp_url = response.data.vimeo_rtmp_url;
                live.vimeo_stream_key = response.data.vimeo_stream_key;
                live.stream_code = response.data.stream_code;
                this.setState({
                    live,
                });

                this.toggleCredentials();
            } else {
                alert('Error retrieving the credentials. Please try again.');
            }
        } catch (error) {
            console.log(error);
        }

        async function getCredentialsInfo(event_date_id) {
            return await ApiRequest(`/box-office/stream/access`, {
                method: 'POST',
                data: {
                    event_date_id,
                    type: 'live-stream',
                }
            });
        }
    }

    toggleCredentials = () => {
        this.setState({
            isCredentialsOpen: !this.state.isCredentialsOpen,
        });
    }

    getRehearsalCredentials = async(event_id, doToggle) => {
        let rehearsal = this.state.rehearsal;
        try {
            const response = await getCredentialsInfo(event_id);
            console.log('getCredentialsInfo', response);

            rehearsal.vimeo_rtmp_url = response.data.vimeo_rtmp_url;
            rehearsal.vimeo_stream_key = response.data.vimeo_stream_key;
            rehearsal.stream_code = response.data.stream_code;
            rehearsal.vimeo_video_id = response.data.vimeo_video_id;
            if (response.data.error) {
                rehearsal.vimeo_error = response.data.error.vimeo_error;
            }
            
            this.setState({
                rehearsal,
            });

            if (doToggle) {
                this.toggleRehearsalCredentials();
            }
            
        } catch (error) {
            console.log(error);
        }

        async function getCredentialsInfo(event_id) {
            return await ApiRequest(`/box-office/stream/access`, {
                method: 'POST',
                data: {
                    event_id,
                    type: 'stream-rehearsal',
                }
            });
        }
    }

    toggleRehearsalCredentials = () => {
        this.setState({
            isRehearsalCredentialsOpen: !this.state.isRehearsalCredentialsOpen,
        });
    }

    copyToClipboard = (inputId: string) => {
        let originalInput = document.getElementById(inputId);
        // Create a new textarea element and give it id='temp_element'
        let textarea = document.createElement('textarea');
        textarea.id = 'temp_element1';
        // Optional step to make less noise on the page, if any!
        textarea.style.height = 0;
        // Now append it to your page somewhere, I chose <body>
        document.body.appendChild(textarea);
        // Give our textarea a value of whatever inside the div of id=containerid
        textarea.value = originalInput.value;
        // Now copy whatever inside the textarea to clipboard
        let selector = document.querySelector('#temp_element1');
        selector.select();
        document.execCommand('copy');
        // Remove the textarea
        document.body.removeChild(textarea);
        setTimeout(function () { originalInput.select(); }, 50); //select all text in any field on focus for easy re-entry. Delay sightly to allow focus to "stick" before selecting.

        // focus & select text in the field
        document.getElementById(inputId).focus();
        document.getElementById(inputId).select();
    }

    renderRehearsalCredentialsModal = () => {
        return (
            <div>
                <Modal
                    isOpen={this.state.isRehearsalCredentialsOpen}
                    toggle={this.toggleRehearsalCredentials}
                    className="showtix-event__modal showtix-event__modal__credentials"
                >
                    <ModalHeader toggle={this.toggleRehearsalCredentials}>
                        {strings.rehearsal.title}
                    </ModalHeader>
                    <ModalBody>
                        <div className="row pt-2">
                            {this.state.rehearsal.vimeo_error && (
                                <div className="col-12">
                                    <div className={"showtix-message showtix-message__error is-active"}>
                                        <div className="showtix-padder">
                                            <p>{ReactHtmlParser(this.state.rehearsal.vimeo_error)}</p>
                                        </div>	
                                    </div>
                                </div>
                            )}
                            <div className="col-12">
                                <div className="showtix-message">
                                    <p
                                        dangerouslySetInnerHTML={{
                                            __html: strings.rehearsal.content2
                                        }}
                                    />
                                </div>
                                <a 
                                    href={`/stream/?vimeoid=${this.state.rehearsal.vimeo_video_id}&eventid=${this.props.event.id}&eventType=${this.props.event.event_type.toLowerCase().replace(/\s/g, '-')}`}
                                    className="showtix-button showtix-background__primary-2"
                                    target="_blank"
                                >
                                    <span>Watch Rehearsal</span>
                                </a>

                                <hr />
                            </div>
                            <div className="col-12 text-left">
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: strings.rehearsal.content3
                                    }}
                                />
                                <div className="showtix-form__group">
                                    <label className="showtix-label" htmlFor="rmtp">{strings.credentials.rmtp}</label>

                                    <div className="showtix-form__input">
                                        <textarea
                                            id="rmtp"
                                            className="showtix-input"
                                            readOnly="true"
                                            rows="2"
                                            onClick={() => this.copyToClipboard('rmtp')}
                                        >
                                            {this.state.rehearsal.vimeo_rtmp_url}
                                        </textarea>
                                    </div>
                                    <div className="mt-3">
                                        <button 
                                            className="showtix-button showtix-background__primary-1"
                                            onClick={() => this.copyToClipboard('rmtp')}
                                        >
                                                <span>{strings.credentials.copy}</span>
                                        </button>
                                    </div>
                                </div>
                                <div className="showtix-form__group">
                                    <label className="showtix-label" htmlFor="key">{strings.credentials.streamKey}</label>

                                    <div className="showtix-form__input">
                                        <textarea
                                            id="key"
                                            className="showtix-input"
                                            readOnly="true"
                                            onClick={() => this.copyToClipboard('key')}
                                            rows="2"
                                        >
                                            {this.state.rehearsal.vimeo_stream_key}
                                        </textarea>
                                    </div>
                                    <div className="mt-3">
                                        <button 
                                            className="showtix-button showtix-background__primary-1"
                                            onClick={() => this.copyToClipboard('key')}
                                        >
                                                <span>{strings.credentials.copy}</span>
                                        </button>
                                    </div>    
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter className="justify-content-center">
		            	<button 
		            		className="showtix-button showtix-background__primary-1"
                            onClick={this.toggleRehearsalCredentials}
		            		>
                                <span>{strings.credentials.ok}</span>
                        </button>
		          	</ModalFooter>
                </Modal>  
            </div>
        )
    }

    renderCredentialsModal = () => {
        return (
            <div>
                <Modal
                    isOpen={this.state.isCredentialsOpen}
                    toggle={this.toggleCredentials}
                    className="showtix-event__modal showtix-event__modal__credentials"
                >
                    <ModalHeader toggle={this.toggleCredentials}>
                        {strings.credentials.title}
                    </ModalHeader>
                    <ModalBody>
                        <div className="row">
                            <div className="col-12 text-left">
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: strings.rehearsal.content3
                                    }}
                                />
                                <div className="showtix-form__group">
                                    <label className="showtix-label" htmlFor="rmtp">{strings.credentials.rmtp}</label>

                                    <div className="showtix-form__input">
                                        <textarea
                                            id="rmtp"
                                            className="showtix-input"
                                            readOnly="true"
                                            rows="2"
                                            onClick={() => this.copyToClipboard('rmtp')}
                                        >
                                            {this.state.live.vimeo_rtmp_url}
                                        </textarea>
                                    </div>
                                    <div className="mt-3">
                                        <button 
                                            className="showtix-button showtix-background__primary-1"
                                            onClick={() => this.copyToClipboard('rmtp')}
                                        >
                                                <span>{strings.credentials.copy}</span>
                                        </button>
                                    </div>
                                </div>
                                <div className="showtix-form__group">
                                    <label className="showtix-label" htmlFor="key">{strings.credentials.streamKey}</label>

                                    <div className="showtix-form__input">
                                        <textarea
                                            id="key"
                                            className="showtix-input"
                                            readOnly="true"
                                            onClick={() => this.copyToClipboard('key')}
                                            rows="2"
                                        >
                                            {this.state.live.vimeo_stream_key}
                                        </textarea>
                                    </div>
                                    <div className="mt-3">
                                        <button 
                                            className="showtix-button showtix-background__primary-1"
                                            onClick={() => this.copyToClipboard('key')}
                                        >
                                                <span>{strings.credentials.copy}</span>
                                        </button>
                                    </div>    
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter className="justify-content-center">
		            	<button 
		            		className="showtix-button showtix-background__primary-1"
                            onClick={this.toggleCredentials}
		            		>
                                <span>{strings.credentials.ok}</span>
                        </button>
		          	</ModalFooter>
                </Modal>  
            </div>
        )
    }

    hasPublicSaleHaveEnded = (date, timezoneString) => {
        let timezone = ReturnTimeZone(this.props.event.venue.timezone || 'EST');
        let timeStringEventEnd = date.sale_end_box_office.substring(0, 16).replace('T', ' ');
        let venueDateTimeUTCEventEnd = moment.tz(timeStringEventEnd, timezone).utc();
        let localUTC = moment().utc();
        let publicSaleHaveEnded = localUTC.isAfter(venueDateTimeUTCEventEnd);
        return publicSaleHaveEnded;
    }

    hasEventsToDisplay = (dates) => {
        let eventsToDisplay = true;
        
        let nbEventsNotPassed = dates.length;

        if (this.props.event.venue) {
        //if(isPatron) {
            dates.map(date => {
                let publicSaleHaveEnded = this.hasPublicSaleHaveEnded(date, this.props.event.venue.timezone);
                if(publicSaleHaveEnded) {
                    nbEventsNotPassed--;
                }
            });
            eventsToDisplay = nbEventsNotPassed > 0;
        //}
        }
        return eventsToDisplay;
    }

    render() {
        let eventClass = '';
        let isPatron = this.props.user.role !== 'client' && this.props.user.role !== 'box-office';
        let hasEventsToDisplay = this.hasEventsToDisplay(this.props.event.event_dates);
        if (isPatron && !hasEventsToDisplay) {
            eventClass = 'd-none';
        }
        if (!isPatron && !hasEventsToDisplay) {
            eventClass = 'is-not-available-patron';
        }
        const hasVenue = this.props.event.venue;
        return (
            <div className={`col-6 col-md-4 col-lg-3 ${eventClass}`}>
                <div className="showtix-event" data-event-type={`${this.props.event.event_type}`}>
                    {(!isPatron && !hasVenue) && (
                        <React.Fragment>
                            <span id={`tooltip-scheduled-${this.props.event.id}`} className="showtix-event__alert is-blink-2 showtix-badge showtix-background__error">!</span>
                            <Tooltip placement="top" target={`tooltip-scheduled-${this.props.event.id}`}>
                                This event has no venue. Please edit your event to add an venue.
                            </Tooltip>
                        </React.Fragment>
                    )}
                    <EventPoster 
                        client={this.props.client}
                        user={this.props.user}
                        is_client={this.props.is_client}
                        current_client_id = {this.props.current_client_id}
                        event={this.props.event}
                        toggleDetails={this.props.toggleDetails}
                        toggleConfirmDeleteEvent={this.props.toggleConfirmDeleteEvent}
                        toggleConfirmEarlyPayout={this.props.toggleConfirmEarlyPayout}
                        handlePrinterChange={this.props.handlePrinterChange}
                        currentPrinter={this.props.currentPrinter}
                        printers={this.props.printers}
                        printerSelect={this.printerSelect}
                        getAccountEventReport={this.props.getAccountEventReport}
                        getStreamAccessReport={this.props.getStreamAccessReport}
                        getTicketPriceSummary={this.props.getTicketPriceSummary}
                        getTicketBreakdown={this.props.getTicketBreakdown}
                        getArtistCreditReport={this.props.getArtistCreditReport}
                        getQuestionTagReport={this.props.getQuestionTagReport}
                        getVenueSeatLabel={this.props.getVenueSeatLabel}
                        toggleWidgetModal={this.props.toggleWidgetModal}
                        isToggleWidgetModalOpen={this.props.isToggleWidgetModalOpen}
                        widgetModalEventID={this.props.widgetModalEventID}
                        getCredentials={this.getCredentials}
                        getRehearsalCredentials={this.getRehearsalCredentials}
                        rehearsal={this.state.rehearsal}
                        startTour={this.startTour}
                        isTourOpen={this.state.isTourOpen}
                    />
                    <EventDates
                        client={this.props.client}
                        user={this.props.user}
                        is_client={this.props.is_client}
                        current_client_id={this.props.current_client_id}
                        client_name={this.props.client_name}
                        event={this.props.event}
                        toggleDate={this.props.toggleDate}
                        toggleAllDates={this.props.toggleAllDates}
                        toggleDateSettings={this.props.toggleDateSettings}
                        toggleAllCategories={this.props.toggleAllCategories}
                        populateTicketSelection={this.props.populateTicketSelection}
                        getSeatingReport={this.props.getSeatingReport}
                        getHouseCount={this.props.getHouseCount}
                        handlePrinterChange={this.props.handlePrinterChange}
                        currentPrinter={this.props.currentPrinter}
                        printers={this.props.printers}
                        printerSelect={this.printerSelect}
                        printersBoca={this.props.printersBoca}
                        printerSelectBoca={this.printerSelectBoca}
                        currentPrinterBoca={this.props.currentPrinterBoca}
                        togglePassword={this.props.togglePassword}
                        setMessage={this.props.setMessage}
                        category={this.props.category}
                        getCredentials={this.getCredentials}
                        getRehearsalCredentials={this.getRehearsalCredentials}
                        isTourOpen={this.state.isTourOpen}
                        printersStar={this.props.printersStar}
                        printersStarUSB={this.props.printersStarUSB}
                        currentPrinterStar={this.props.currentPrinterStar}
                        handlePrinterChangeStar={this.props.handlePrinterChangeStar}
                    />
                    <EventDetails
                        event={this.props.event}
                        toggleDetails={this.props.toggleDetails}
                        client_name={this.props.client_name}
                    />
                    {this.renderCredentialsModal()}
                    {this.renderRehearsalCredentialsModal()}
                    <Tour
                        steps={steps}
                        isOpen={this.state.isTourOpen}
                        onRequestClose={this.closeTour}
                        showNavigation={true}
                        showButtons={false}
                    />
                </div>
            </div>
        );
    }
}

Event.propTypes = {
    event: PropTypes.object,
    is_client: PropTypes.bool,
    toggleDetails: PropTypes.func,
    toggleConfirmDeleteEvent: PropTypes.func,
    toggleDate: PropTypes.func,
    toggleAllDates: PropTypes.func,
    toggleDateSettings: PropTypes.func,
    toggleAllCategories: PropTypes.func,
    populateTicketSelection: PropTypes.func
}

export default Event;


// WEBPACK FOOTER //
// ./src/components/EventListing/Event/Event.js